// extracted by mini-css-extract-plugin
module.exports = {"lines":"index_lines__240Zo","resourceShow":"index_resourceShow__2EP7b","descriptionList":"index_descriptionList__3yyjj","card":"index_card__1mdKa"};